<template>
  <vs-row>
    <vs-col vs-lg="8" vs-sm="8" vs-xs="12">
      <form id="reasonNew" class="form form-vertical" onsubmit="return false">
      <div class="mb-5">
        <div class="header">
          <div class="vx-row mb-6">
            <div class="vx-col w-full">
              <vs-input 
                name="description"
                v-validate="'required'"
                class="mb-4 w-full"
                label-placeholder="Título da Métrica Inteligente"
                v-model="description"
              ></vs-input>
              <span
                class="text-danger text-sm"
                v-show="errors.has('description')"
              >
                Informe um valor válido para o Título.
              </span>
            </div>
          </div>

          <div class="mb-8">
            <vs-row>
              <vs-col vs-w="6">
                <div class="w-full flex">
                  <span>Exibir Campo de Observação?</span>
                </div>
                <div class="w-full mt-4 flex">
                  <vs-switch v-model="useObservation">
                    <span slot="on">Sim</span>
                    <span slot="off">Não</span>
                  </vs-switch>
                </div>
              </vs-col>

              <vs-col vs-w="6" v-if="useObservation">
                <div>
                  <div class="w-full flex">
                    <span>Observação Obrigatória?</span>
                  </div>
                  <div class="w-full mt-4 flex">
                    <vs-switch v-model="requireObservation">
                      <span slot="on">Sim</span>
                      <span slot="off">Não</span>
                    </vs-switch>
                  </div>
                </div>
              </vs-col>
            </vs-row>
          </div>
        </div>
      </div> <hr>

      <div>
        <div class="mt-5 text-center">
          <h6>OPÇÕES</h6>
          <p v-if="options.length === 0">Nenhuma opção cadastrada</p>
        </div>

        <div>
          <component
            :index="index"
            @onRemoveReasonOption="removeReasonOption"
            :list="reasonOptionsAttributes[index]"
            v-for="(option, index) in options"
            :key="index"
            :is="option"
            class="body mt-5"
          />
          <vs-button 
            type="flat" 
            @click.prevent="addOption"
          >
            Adicionar Opção
          </vs-button>
        </div>
      </div>

      <div class="w-full d-flex justify-content-flex-end">
        <vs-button @click.prevent="create">Salvar</vs-button>
      </div>
      </form>
    </vs-col>
    <vs-col vs-lg="4" vs-sm="4" vs-xs="0" style="display: block;">
      <div style="position: sticky; top: 0; padding-top: 15px">
        <reasons-preview :use_observation="useObservation" :reason_options.sync="reasonOptionsAttributes"></reasons-preview>
      </div>
    </vs-col>
  </vs-row>
</template>
<script>
  import requests from '@/http/requests/reasons'
  import ReasonOptionForm from '@/views/reason-options/Form'
  import ReasonsPreview from "@/components/reasons/ReasonsPreview.vue";
  import { formatRouteTenantPath } from '@/utils'
  import { reasonType } from "@/supports/reasonSupport";

  export default {
    name: 'reasons-form-popup',
    provide() {
      return {
        $validator: this.$validator,
      }
    },
    components: { ReasonsPreview, ReasonOptionForm },
    data() {
      return {
        options: [],
        reasonOptionsAttributes: [],
        description: '',
        useObservation: false,
        requireObservation: false,
      }
    },
    created () {},
    methods: {
      addOption () {
        this.reasonOptionsAttributes.push({
          description: '',
          is_required: false,
          number: this.options.length,          
          reason_option_items_attributes: []
        })
        
        this.options.push(ReasonOptionForm);
      },
      removeReasonOption (idx) {
        this.reasonOptionsAttributes.splice(idx, 1)
        this.options.splice(idx, 1)
      },
      create () {
        this.$validator.validateAll().then((valid) => {
          if(!valid) {
            return
          }
          this.$store.dispatch('setShowLoadingOverlay', true)

          let dataToPost = this.reasonOptionsAttributes

          dataToPost.map((item) => {
            delete item["reason_option_kind"]
            return item
          });

          let args = {
            type: reasonType,
            description: this.description,
            use_observation: this.useObservation,
            require_observation: this.requireObservation,
            reason_options_attributes: dataToPost,
          }

          this.$store.dispatch('setShowLoadingOverlay', true)

          requests.create(args).then(() => {
            this.$store.dispatch('setShowLoadingOverlay', false);
            this.$vs.notify({
              color: 'success',
              title: 'Sucesso!',
              text: 'Métrica Inteligente foi criada com sucesso'
            })
            this.$router.push(formatRouteTenantPath('/crm/reasons'))
          });
        }).catch((error) => {
          this.$store.dispatch('setShowLoadingOverlay', false)
          console.log(error)
        })
      }
    },
  }
</script>

<style lang="scss">
  #reasonNew {
    .body {
      border: none;
      padding: 10px; 
      background: #fff;
      border-radius: 10px;
      box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.090);
    }
  }
</style>